package com.ervasstudio.tracoemovimento.pages.cursos.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.GoogleLoginButton
import com.ervasstudio.tracoemovimento.model.GoogleUser
import com.ervasstudio.tracoemovimento.util.Res.MyColors.Lilas
import com.ervasstudio.tracoemovimento.util.Res.MyColors.PretoDesfalecido
import com.ervasstudio.tracoemovimento.util.Res.MyColors.SurfaceContent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.AlignItems.Companion.Center
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div

@Composable
fun LoginFormContent(
    email: String,
    onEmailChange: (String) -> Unit,
    senha: String,
    onSenhaChange: (String) -> Unit,
    naoTenhoContaClick: () -> Unit,
    onEntrarClick: () -> Unit,
    externalError: String?,
    emailError: String?,
    senhaError: String?,
    emailErrorChange: (String?) -> Unit,
    senhaErrorChange: (String?) -> Unit,
    isLoging: Boolean,
    isLogingChange: (Boolean) -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
    isMobile: Boolean,
) {
    val emailRegex = "^[A-Za-z0-9+_.-]+@(.+)\$".toRegex()
    var mostrarSenha by remember { mutableStateOf(false) }

    val alturaCampo = if (isMobile) 44.px else 48.px   // era 48.px fixo

    Column(
        modifier = if (isMobile) Modifier.fillMaxWidth() else Modifier.width(320.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            text = "Entarar",
            modifier = Modifier
                .fontFamily("GothamBlack")
                .fontSize(if (isMobile) 19.px else 22.px)   // era 22.px
                .color(PretoDesfalecido)
                .margin(bottom = if (isMobile) 0.6.cssRem else 1.cssRem)
        )
        SpanText(
            text = "para continuares na tua conta.",
            modifier = Modifier
                .fontFamily("GothamBook")
                .fontSize(if (isMobile) 14.px else 16.px)   // era 16.px
                .color(PretoDesfalecido)
                .margin(bottom = if (isMobile) 18.px else 24.px)
        )

        Input(
            type = InputType.Email,
            value = email,
            onValueChange = {
                onEmailChange(it)
                if (emailError != null) emailErrorChange(null)
            },
            placeholder = "exemplo@email.com",
            modifier = inputModifier(alturaCampo)
                .margin(bottom = if (emailError != null || externalError != null) 2.px else 12.px)
        )
        (emailError ?: externalError)?.let {
            SpanText(
                it,
                Modifier.color(Colors.Red).fontSize(if (isMobile) 11.px else 12.px)
                    .margin(bottom = 12.px).fontFamily("GothamBook")
            )
        }

        Div(attrs = { style { position(Position.Relative); width(100.percent) } }) {
            Input(
                type = if (mostrarSenha) InputType.Text else InputType.Password,
                value = senha,
                onValueChange = {
                    onSenhaChange(it)
                    if (senhaError != null) senhaErrorChange(null)
                },
                placeholder = "Senha",
                modifier = inputModifier(alturaCampo)
                    .padding(right = 50.px, left = if (isMobile) 16.px else 20.px)   // era left = 20.px
                    .margin(bottom = if (senhaError != null) 2.px else 12.px)
            )

            Button(onClick = { mostrarSenha = !mostrarSenha }, modifier = Modifier
                    .position(Position.Absolute)
                    .right(8.px).top(value = 0.px)
                    .width(40.px).height(alturaCampo)   // era height(48.px)
                    .display(DisplayStyle.Flex)
                    .alignItems(Center)
                    .justifyContent(JustifyContent.Center)
                    .backgroundColor(Colors.Transparent)
                    .styleModifier {
                        property("border", "none")
                        property("cursor", "pointer")
                        property("padding", "0")
                    }) {
                SpanText(
                    if (mostrarSenha) "👁" else "👁",
                    Modifier.fontSize(if (isMobile) 16.px else 18.px).color(Colors.Gray)   // era 18.px
                )
            }
        }

        senhaError?.let {
            SpanText(
                it,
                Modifier.color(Colors.Red).fontSize(if (isMobile) 11.px else 12.px)
                    .margin(bottom = 12.px).fontFamily("GothamBook")
            )
        }

        Button(
            onClick = {
                if (isLoging) return@Button
                var isValid = true

                val normalizedEmail = email.trim().lowercase()
                if (!normalizedEmail.matches(emailRegex)) {
                    emailErrorChange("Formato de e-mail inválido.")
                    isValid = false
                }

                when {
                    senha.isBlank() -> {
                        senhaErrorChange("Digite uma senha.")
                        isValid = false
                    }
                    senha.length < 8 -> {
                        senhaErrorChange("A senha deve ter pelo menos 8 caracteres.")
                        isValid = false
                    }
                    !senha.any { it.isLetter() } -> {
                        senhaErrorChange("A senha deve conter pelo menos uma letra.")
                        isValid = false
                    }
                    !senha.any { it.isDigit() } -> {
                        senhaErrorChange("A senha deve conter pelo menos um número.")
                        isValid = false
                    }
                }

                if (isValid) {
                    isLogingChange(true)
                    onEntrarClick()
                }
            },
            modifier = Modifier
                .fillMaxWidth()
                .height(alturaCampo)   // era height(48.px)
                .borderRadius(24.px)
                .backgroundColor(Lilas)
                .styleModifier { property("border", "none") }
        ) {
            SpanText(
                if (isLoging) "Entrando..." else "Entrar",
                Modifier.fontFamily("GothamBlack").fontSize(if (isMobile) 14.px else 16.px).color(White)   // era sem fontSize explícito
            )
        }

        Row(
            modifier = Modifier.fillMaxWidth().margin(topBottom = if (isMobile) 16.px else 24.px),   // era 24.px
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(Modifier.weight(1f).height(1.px).backgroundColor(Colors.LightGray))
            SpanText(
                text = "Outras opções de inscrição",
                modifier = Modifier.padding(leftRight = 8.px).fontSize(if (isMobile) 11.px else 12.px).color(Colors.Gray)
            )
            Box(Modifier.weight(1f).height(1.px).backgroundColor(Colors.LightGray))
        }

        GoogleLoginButton(onSuccess = onGoogleLoginButtonClick, onError = {})

        SpanText(
            text = "Ao entrar, você concorda com nossos Termos de Uso e com a Política de Privacidade.",
            modifier = Modifier
                .textAlign(TextAlign.Center)
                .fontFamily("GothamBook")
                .fontSize(if (isMobile) 11.px else 12.px)   // era 12.px
                .margin(top = if (isMobile) 12.px else 0.px, bottom = if (isMobile) 12.px else 16.px)
        )

        Button(
            onClick = { naoTenhoContaClick() },
            modifier = Modifier
                .fillMaxWidth()
                .height(if (isMobile) 40.px else 44.px)   // era 44.px
                .borderRadius(24.px)
                .backgroundColor(color = SurfaceContent)
                .styleModifier { property("border", "none") }
        ) {
            SpanText(
                "Não tenho uma conta? Me cadastrar",
                Modifier.fontFamily("GothamBook").fontWeight(FontWeight.Bold).fontSize(if (isMobile) 12.px else 13.px)   // era 13.px
            )
        }
    }
}

private fun inputModifier(altura: CSSSizeValue<CSSUnit.px> = 48.px) = Modifier
    .fillMaxWidth()
    .height(altura)   // era height(48.px) fixo
    .borderRadius(24.px)
    .border(1.px, LineStyle.Solid, Colors.Black)
    .padding(leftRight = 16.px)
    .styleModifier {
        property("outline", "none")
    }